import dayjs from "dayjs";

import type { AccessionLogResponse } from "../../services/reports.service";
import { billingDateBasisLabel } from "./billingReportLabels";
import styles from "./BillingReportPrint.module.css";

interface AccessionLogPrintReportProps {
  report: AccessionLogResponse;
}

export function AccessionLogPrintReport({
  report,
}: AccessionLogPrintReportProps) {
  return (
    <main className={styles.page} data-billing-report-document="true">
      <h1 className={styles.title}>Accession Log</h1>
      <section className={styles.metadata}>
        <p className={styles.metadataLine}>
          Generated At: {report.generatedAt}
        </p>
        <p className={styles.metadataLine}>
          Filtered By: {billingDateBasisLabel(report.dateBasis)}
        </p>
        <p className={styles.metadataLine}>
          From: {report.startDate} - {report.endDate}
        </p>
        <p className={styles.metadataLine}>
          Prefixes: {report.prefixFilterLabel ?? "All prefixes"}
        </p>
      </section>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Accession #</th>
            <th>Patient</th>
            <th>Physician</th>
            <th>Collected Date</th>
            <th>Received Date</th>
            <th>Specimen</th>
            <th>Pathologist</th>
          </tr>
        </thead>
        <tbody>
          {report.rows.map((row) => (
            <tr key={row.caseId}>
              <td>{row.accessionNumber}</td>
              <td>{row.patientName}</td>
              <td>{row.physicianName}</td>
              <td>{displayDate(row.collectedDate)}</td>
              <td>{displayDate(row.receivedDate)}</td>
              <td>
                {row.specimens.map((specimen) => (
                  <div key={specimen}>{specimen}</div>
                ))}
              </td>
              <td>{row.pathologistName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}

function displayDate(value: string): string {
  return value ? dayjs(value).format("MM/DD/YYYY") : "Not recorded";
}
